import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'auth/login' },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.AUTH_ROUTES),
  },
  {
    path: 'secure',
    loadChildren: () => import('./features/secure/secure.routes').then(m => m.SECURE_ROUTES),
  },
  { path: '**', redirectTo: 'auth/login' },
];
